import React, { PureComponent } from "react";
import _ from "lodash";
import VerbodenGameLayout from "../../../components/verbodenGameLayout";
// import Results from "../../../assets/images/verboden/result.png";
import ResultGif from "../../../assets/images/verboden/ResultGif.gif";
import EyeWinLeft from "../../../assets/images/verboden/gif/Eye-Win-Left.gif";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { motion } from "framer-motion";
import { fadeVariants } from "../../../components/shared/utils/animations";
class VerbodenResult extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      overGif: ""
    };
  }

  componentWillMount() {
    const { paramsReducer } = this.props;
    const screenObj = _.get(paramsReducer, "gameObj.screens", {});
    let image = _.get(screenObj, "vb.over_gif");
    this.setState({ overGif: image });
  }
  render() {
    let roomData = this.props.gameReducer.roomObj;
    const { paramsReducer } = this.props;
    const screenObj = _.get(paramsReducer, "gameObj.screens", {});
    const overHeaderLabel = _.get(screenObj, "vb.over_header", "GAME OVER");
    const finalScoreLabel = _.get(
      screenObj,
      "vb.final_score_label",
      "Final Scores"
    );
    // const overGif = _.get(screenObj, "vb.over_gif") || ResultGif;
    let winningTeam = "A";

    let teamAScore = 0;
    let teamBScore = 0;
    if (
      roomData &&
      roomData.game_state &&
      roomData.game_state.teams &&
      roomData.game_state.teams.length > 0
    ) {
      if (roomData.game_state.teams[0]) {
        teamAScore = roomData.game_state.teams[0].score;
      }
      if (roomData.game_state.teams[0]) {
        teamBScore = roomData.game_state.teams[1].score;
      }
      if (teamAScore < teamBScore) {
        winningTeam = "B";
      }
      if (roomData.game_state.status === "PreGuess") {
        return <Redirect to={"/verboden/play"} />;
      }
      return (
        <VerbodenGameLayout>
          <div
            key="vb_1"
            className="verboden-game-play text-center final-results-wrapper"
          >
            <motion.div
              variants={fadeVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              className="eye-set"
            >
              {/* <img src={this.state.overGif} className="result-img" /> */}
              <img src={EyeWinLeft} className="result-img" />
            </motion.div>
            <motion.div
              variants={fadeVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              className={`final-result ${
                winningTeam === "A"
                  ? "teamA"
                  : teamAScore === teamBScore
                  ? " tie"
                  : "teamB"
              }`}
            >
              <div>
                <h2 className="mb-3">{overHeaderLabel}</h2>
                <h1>
                  {teamAScore === teamBScore
                    ? "Tie Game!"
                    : `Team ${winningTeam} Wins!`}
                </h1>
              </div>
              <div>
                {/* <p className="text score-text">{finalScoreLabel}</p> */}
                <div className="d-flex justify-content-center">
                  <div className="final-scores">
                    <div>
                      <div className="text-white  teamA-scores">
                        <div className="score-bg"></div>
                        <span>{teamAScore}</span>
                      </div>
                      <p className="text-lightGreen team-name">Team A</p>
                    </div>
                    <div>
                      <div className="text-white  teamB-scores">
                        <div className="score-bg"></div>
                        <span>{teamBScore}</span>
                      </div>

                      <p className="text-lightPurple team-name">Team B</p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </VerbodenGameLayout>
      );
    } else {
      return <></>;
    }
  }
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});

export default connect(mapStateToProps, null)(VerbodenResult);
